<script lang="ts">
  const targetHex = '#D92027';

  const promptTokens = ['Name', 'this', 'paint', 'color:'];

  const rollouts = [
    { label: 'A', name: 'Coral Pink' },
    { label: 'B', name: 'Royal Red' },
    { label: 'C', name: 'Rose Gold' },
    { label: 'D', name: 'Ruby Red' },
  ];

  const layers = [5, 7, 5];
  const modelW = 260;
  const modelH = 150;
  const padX = 20;
  const padY = 15;

  type Node = { x: number; y: number; col: number };
  const nodes: Node[] = [];
  layers.forEach((count, col) => {
    const colX = padX + col * ((modelW - 2 * padX) / (layers.length - 1));
    const stepY = (modelH - 2 * padY) / (count - 1);
    for (let i = 0; i < count; i++) {
      nodes.push({ x: colX, y: padY + i * stepY, col });
    }
  });

  const connections: [Node, Node][] = [];
  for (let c = 0; c < layers.length - 1; c++) {
    const a = nodes.filter((n) => n.col === c);
    const b = nodes.filter((n) => n.col === c + 1);
    for (const n1 of a) for (const n2 of b) connections.push([n1, n2]);
  }
</script>

<div class="gen">
  <div class="row">
    <div class="eyebrow">Prompt</div>
    <div class="tokens">
      {#each promptTokens as t}
        <span class="chip">{t}</span>
      {/each}
      <span class="chip chip-hex">
        <span class="swatch" style:background={targetHex}></span>
        <span class="hex">{targetHex}</span>
      </span>
    </div>
  </div>

  <div class="arrow-down"></div>

  <svg
    class="model"
    width="100%"
    height="auto"
    viewBox="0 0 {modelW} {modelH}"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    {#each connections as [n1, n2]}
      <line x1={n1.x} y1={n1.y} x2={n2.x} y2={n2.y} stroke="#c9c9c9" stroke-width="0.6" />
    {/each}
    {#each nodes as n}
      <circle cx={n.x} cy={n.y} r="5" fill="#ffffff" stroke="#333333" stroke-width="1.25" />
    {/each}
  </svg>

  <div class="arrow-down"></div>

  <div class="row">
    <div class="eyebrow">Rollouts</div>
    <div class="rollouts">
      {#each rollouts as r}
        <span class="chip chip-rollout">
          <span class="rollout-label">{r.label}</span>
          <span class="rollout-sep">·</span>
          <span class="rollout-name">{r.name}</span>
        </span>
      {/each}
    </div>
  </div>
</div>

<style>
  .gen {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    margin: 32px 0;
    font-family: 'Diatype', 'ABC Diatype', Arial, sans-serif;
    color: #333;
  }

  .row {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .eyebrow {
    font-family: 'Geist Mono', 'SF Mono', ui-monospace, monospace;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8a8a8a;
  }

  .tokens,
  .rollouts {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .chip {
    padding: 7px 12px;
    border: 1px solid #333;
    border-radius: 7px;
    font-family: 'Geist Mono', 'SF Mono', ui-monospace, monospace;
    font-size: 15px;
    background: transparent;
    color: #333;
    line-height: 1;
  }

  .chip-hex {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px 6px 8px;
  }

  .swatch {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    border: 1px solid #333;
    flex-shrink: 0;
    display: inline-block;
  }

  .hex {
    letter-spacing: 0.01em;
  }

  .chip-rollout {
    display: inline-flex;
    align-items: baseline;
    gap: 5px;
    border-color: #0891b2;
    color: #0891b2;
  }

  .rollout-label {
    font-weight: 600;
  }

  .rollout-sep {
    color: #a5d8e4;
  }

  .rollout-name {
    color: #0891b2;
  }

  .arrow-down {
    width: 1px;
    height: 18px;
    background: #333;
    position: relative;
  }

  .arrow-down::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid #333;
  }

  .model {
    display: block;
    width: 300px;
    max-width: 100%;
    height: auto;
  }
</style>
